import { HttpResponse } from 'shell/models/http-response';
import { AxiosResponse } from 'axios';
import { ResponseAmount } from 'shell/models/response-amount';
import { DateTime } from 'luxon';
import { AmountForm } from 'front-office/components/amount/form';

export const transformerAmount = (
  response: AxiosResponse<HttpResponse<ResponseAmount>>
): AmountForm => {
  const data = response.data.payload || {};

  return {
    code: data.key?.codiceImportoPagamento || undefined,
    description: data.descrizioneImportoPagamento || undefined,
    amount: data.importoPagamento || undefined,
    dateFrom: data.dataInizioValidita ? DateTime.fromISO(data.dataInizioValidita) : null,
    dateTo: data.dataFineValidita ? DateTime.fromISO(data.dataFineValidita) : null,
    codeAgency: data.key?.codiceEnte || undefined, // to request
  };
};
